import { render, staticRenderFns } from "./Chapar.vue?vue&type=template&id=1568ddac&scoped=true"
import script from "./Chapar.vue?vue&type=script&lang=js"
export * from "./Chapar.vue?vue&type=script&lang=js"
import style0 from "./Chapar.vue?vue&type=style&index=0&id=1568ddac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1568ddac",
  null
  
)

export default component.exports